import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import { transform } from "ol/proj";
import { FerryListDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { ferryToMapItem } from "./dataConverters";
import { findSourceByTitle } from "./findSourceByTitle";

export function addFerriesToMap(
  map: Map,
  ferries: FerryListDto[],
  allowInactive = false,
): void {
  // Find the ferries layer and add the ferries as features
  const source = findSourceByTitle(map, LayerTitle.Ferries);
  // Clear the source before adding
  source.clear();
  const features: Feature<Geometry>[] = [];
  ferries.forEach((e) => {
    // Convert to internal type
    const convertedFerry = ferryToMapItem(e);
    if (!convertedFerry.active && !allowInactive) return;
    // Ferry locations are in EPSG:4326 in db
    const transformed = transform(
      [convertedFerry.location.x, convertedFerry.location.y],
      "EPSG:4326",
      "EPSG:3857",
    );
    const point = new Point(transformed);
    const feat = new Feature({
      geometry: point,
    });
    feat.setProperties({ ...convertedFerry });
    feat.set("overlayOffsetY", -24);
    feat.setId(convertedFerry.mapId);
    features.push(feat);
  });
  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
